import type { InjectionKey } from 'vue'
import type { HttpRequest } from '@zoryn/network'

export const GRID_HTTP_INJECTION_KEY: InjectionKey<HttpRequest> = Symbol('ZGridHttp')
